// src/components/liveOrder/liveOrder.store.js

const LS_KEY = "mlk.orders";

export function loadOrders() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveOrders(list) {
  localStorage.setItem(LS_KEY, JSON.stringify(list));
}

// ✅ single addOrder that also fires the toast event
// src/components/liveOrder/liveOrder.store.js

function notifyChanged(payload) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("mlk:orders_changed", { detail: payload }));
  }
}

export function addOrder(order) {
  const all = loadOrders();
  const withId = { ...order, id: String(order.id ?? Date.now()) };
  const next = [withId, ...all];
  saveOrders(next);

 
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("mlk:new_order", { detail: withId }));
  }

  notifyChanged({ type: "add", order: withId });

  return withId;
}

export function updateOrder(id, patch) {
  const all = loadOrders();
  const next = all.map(o => (String(o.id) === String(id) ? { ...o, ...patch } : o));
  saveOrders(next);

  const updated = next.find(o => String(o.id) === String(id));
  
  notifyChanged({ type: "update", order: updated });

  return updated;
}



export function clearOrders() {
  localStorage.removeItem(LS_KEY);

  // 🔥 notify all listeners (same as add/update)
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("mlk:orders_changed", {
        detail: { type: "clear" }
      })
    );
  }
}



if (typeof window !== "undefined") {
  window.liveOrders = {
    add: addOrder,         
    update: updateOrder,
    list: loadOrders,
    clear: clearOrders,
    demo(n = 10) {
      const items = ["Paneer Masala", "Naan", "Veg Biryani", "Dal Tadka", "Butter Roti"];
      const statuses = ["pending", "inProcess", "accepted", "declined"]; // delivered set manually
      const base = Array.from({ length: n }, (_, i) => ({
        id: 1000 + i,
        customer: { name: `Customer ${i + 1}` },
        placedAt: new Date(Date.now() - i * 60_000).toISOString(),
        items: [
          { id: "it1", name: items[i % items.length], qty: 1 },
          { id: "it2", name: items[(i + 2) % items.length], qty: 1 + (i % 3) },
        ],
        total: 200 + i * 5,
        currency: "INR",
        status: statuses[i % statuses.length],
      }));
      saveOrders(base);
      return base;
    },
  };
}
